import React from "react";
import {
  BrowserRouter as Router,
  Routes ,
  Route
} from "react-router-dom";


import Questions from "./assessment/Questions";


import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";




const getBasename = () => {
  ///return '/'+process.env.PUBLIC_URL.split('/').pop();
  ///return "/reacteasetolearn";
  return "";
};

function App() {

  return (
    <Router basename={getBasename()} >
      <div>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Routes> 

          
          <Route exact path="/forgotpassword" element={<ForgotPassword/>} />
          <Route exact path="/resetpassword" element={<ResetPassword/>} />  

          
          <Route exact path="/login" element={<Login />} />  
          {/* <Route exact path="/" element={<Login />} />   */}
          
          <Route exact path="/" element={<Questions/>} />
          
        </Routes >
      </div>
    </Router>
  );
}

export default App;
